var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',[_c('v-content',[_c('div',{staticClass:"message text-xs-center pt-5"},[_c('h1',[_vm._v("Page not found")]),_c('v-card',[_c('v-card-text',[_c('v-btn',{attrs:{"to":"/"}},[_vm._v("Home")])],1)],1)],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }